import { Link } from "react-router-dom";
import { ReactNode } from "react";
import { Wordmark } from "@/components/brand/Wordmark";

interface AuthLayoutProps {
  children: ReactNode;
  eyebrow?: string;
  heading: string;
  description?: ReactNode;
  testId?: string;
}

export function AuthLayout({
  children,
  eyebrow,
  heading,
  description,
  testId,
}: AuthLayoutProps) {
  return (
    <main
      data-testid={testId ?? "auth-layout"}
      className="min-h-screen bg-background text-foreground flex flex-col"
    >
      <header className="px-6 md:px-12 py-6 flex items-center justify-between">
        <Link
          to="/"
          data-testid="auth-wordmark"
          className="font-display text-xl tracking-tight"
        >
          <Wordmark className="h-8 md:h-9" />
        </Link>
        <Link
          to="/"
          data-testid="auth-back-home"
          className="text-xs uppercase tracking-[0.2em] text-muted-foreground hover:text-oxblood transition-colors"
        >
          ← Back
        </Link>
      </header>

      <section className="flex-1 grid place-items-center px-6 py-10">
        <div className="w-full max-w-md">
          {eyebrow && (
            <p className="text-[11px] uppercase tracking-[0.28em] text-oxblood font-medium mb-4">
              — {eyebrow}
            </p>
          )}
          <h1
            data-testid="auth-heading"
            className="font-display text-3xl sm:text-4xl leading-tight text-balance"
          >
            {heading}
          </h1>
          {description && (
            <p className="mt-4 text-sm md:text-base text-muted-foreground leading-relaxed">
              {description}
            </p>
          )}
          <div className="mt-8">{children}</div>
        </div>
      </section>

      <footer className="px-6 md:px-12 py-6 text-xs text-muted-foreground">
        © {new Date().getFullYear()} Wardrobe Index
      </footer>
    </main>
  );
}
